import React, { useRef, useState } from 'react'
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

const Relatedowl = ({item,catid,catpage}) => {
    const nvg = useNavigate()
    const location = useLocation();
    const [activecls,setactivecls] = useState("")
    const [hover, setHover] = useState([false,null]);
    const hoverRef = useRef(hover);
    const { bgColor, textColor } = useSelector((state) => state.theam);
    const transfer = (productid)=>{
        console.log("check all data is here",{ id: productid,categoryid:catid,pagename:catpage,pname:item.recommended_products__children__title})
        nvg("/bulkproductdetails",{ state: { id: productid,categoryid:catid,pagename:catpage,pname:item.recommended_products__children__title} });
        window.location.reload();
      }
  return (
    <div 
                          // onMouseEnter={()=>{handleMouseEnter(item?.id)}}
                          // onMouseLeave={handleMouseLeave }
                          onMouseEnter={()=>{setactivecls(item?.id)}}
                          onMouseLeave={()=>{setactivecls("")} }
                           >
                             <div
                                                  className=""
                                                  style={{ marginRight: "12px", marginBottom: "3px" }}
                                                  
                                                  >
                                                  <div
                                                    className="product-box product-box2"
                                                    style={{ paddingRight: "0px"}}
                                                    onClick={() => {
                                                      // nvg("/bulkproductdetails", {
                                                      //   state: {
                                                      //     id: item.id,
                                                      //     pname: item.title,
                                                      //     categoryid: item.id,
                                                      //     pagename: item.title,
                                                      //   },
                                                      // });
                                                      console.log("abckddkdkd",item.id,item.title)
                                                    }}
                                                  >
                                                    
                                                   
                                                    <div className="product-imgbox2new" 
                                                    style={{position: "relative", overflow: "hidden"}}
                                                    onClick={() => {
                                                      transfer(item.recommended_products__children, item.recommended_products__children__title);
                                                    }} >
                                                    {item.stock[0]?.stock <= 0 && (<div className="overlay" onClick={() => {
                                                                          transfer(item.recommended_products__children, item.recommended_products__children__title);
                                                                        }}></div>)}
                                                                    {item.stock[0]?.stock <= 0 && (
                                                                      <div className="out-of-stock" style={{ backgroundColor: `#${bgColor}`}}
                            >Out of Stock</div>
                                                                    )}
                                                      <div className="product-front">
                                                        <a href="javascript:void(0)">
                                                          <img src={`${process.env.REACT_APP_API_URL}media/${item.image[0]}`} alt="" />
                                                        </a>
                                                      </div>
                            
                                                      {/* <div className="on-sale1">on sale</div> */}
                                                    </div>
                                                    <div className="product-detail product-detail2">
                                                      {/* <p>{item?.id}</p>
                                                    
                                                      <p>{hoverRef.current[1]} id</p>
                                                      <p>{hoverRef.current[0]} bool</p> */}
                      
                      
                                                      <a href="javascript:void(0)">
                                                      <div 
                        style={{ position: "relative", display: "inline-block", maxWidth: "240px" }} 
                        onMouseEnter={() => { hoverRef.current = [true, item?.id]; }}
                        onMouseLeave={() => { hoverRef.current = [false, null]; }}
                      >
                        {/* Title */}
                        <h6
                          className="price-title catbox2"
                          style={{
                            color:
                            activecls === item?.id
                                ? "#808080"
                                : "black",
                            // color:
                            //   hoverRef.current[0] && hoverRef.current[1] === item?.id
                            //     ? "#808080"
                            //     : "black",
                            fontSize: "14px",
                            fontWeight: "100",
                            height: "40px",
                            lineHeight: "20px",
                            display: "-webkit-box",
                            WebkitBoxOrient: "vertical",
                            WebkitLineClamp: 2,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "normal",
                            maxWidth: "240px",
                          }}
                        >
                         <span style={{color:'green'}}> {`${item?.brands?.length > 0 ? item?.brands.find((item)=>(item.code == "brand")).value + ":" : ""}`}</span>
                         {item?.recommended_products__children__title}
                        </h6>
                      
                        {/* Tooltip (Full Title) */}
                        {activecls === item?.id && (
                          <span
                            style={{
                              position: "absolute",
                              bottom: "50px",
                              left: "50%",
                              transform: "translateX(-50%)",
                              backgroundColor: "rgba(0, 0, 0, 0.8)",
                              color: "#fff",
                              fontSize: "10px",
                              fontWeight: "400",
                              textAlign: "center",
                              borderRadius: "5px",
                              padding: "6px 10px",
                              zIndex: 10,
                              width: "max-content",
                              maxWidth: "250px",
                              whiteSpace: "normal",
                              wordWrap: "break-word",
                              opacity: 1,
                              transition: "opacity 0.2s ease-in-out",
                              boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",
                            }}
                          >
                            <span> {`${item?.brands?.length > 0 ? item?.brands.find((item)=>(item.code == "brand")).value + ":" : ""}`}</span>
                            {` ${item?.recommended_products__children__title}`}
                          </span>
                        )}
                      </div>
                      
                                                      </a>
                                                      <h5
                                                        style={{
                                                          fontSize: "14px",
                                                          fontWeight: "500",
                                                          color: "black",
                                                        }}
                                                      >
                                                        {new Intl.NumberFormat("en-IN", {
                        style: "currency",
                        currency: "INR",
                        minimumFractionDigits: 0, 
                        maximumFractionDigits: 0, 
                      }).format(parseInt(item.stock[0]?.price))}
                                                    
                                                        {item.stock[0]?.discount == 0 ? (
                                                          ""
                                                        ) : (
                                                          <span
                                                            style={{
                                                              fontSize: "13px",
                                                              color: "#c1c1c1",
                                                              lineHeight: "20px",
                                                              textDecoration: "line-through",
                                                              paddingLeft: "3px",
                                                              fontWeight: "400",
                                                            }}
                                                          >
                                                            {new Intl.NumberFormat("en-IN", {
                        style: "currency",
                        currency: "INR",
                        minimumFractionDigits: 0, 
                        maximumFractionDigits: 0, 
                      }).format(parseInt(item.stock[0]?.mrp))}
                                                            {/* ₹{parseInt(item.stock[0]?.mrp)} */}
                                                          </span>
                                                        )}
                                                        {item.stock[0]?.discount == 0 ? (
                                                          ""
                                                        ) : (
                                                          <span
                                                            style={{
                                                              fontSize: "12px",
                                                              textDecoration: "none",
                                                              color: "#388e3c",
                                                              lineHeight: "20px",
                                                              paddingLeft: "3px",
                                                              fontWeight: "400",
                                                            }}
                                                          >
                                                            {item.stock[0]?.discount_type == "amount"
                                                              ? `(₹${item.stock[0]?.discount} off)`
                                                              : `(${item.stock[0]?.discount} %off)`}
                                                          </span>
                                                        )}
                                                      </h5>
                                                    </div>
                                                  </div>
                                                </div>
                          </div>
  )
}

export default Relatedowl